class StyleProfile {
  constructor() {
    this.vars = window.statelyVars || {};
    this.apiUrl = this.vars.api?.erp || '';
    this.customerId = this.vars.customer?.id || '';
    this.customerEmail = this.vars.customer?.email || '';
    this.isStyleProfile = document.querySelector('.quiz.style-profile') !== null;
    this.currentSlide = 0;
    this.slides = document.querySelectorAll('.quiz-slide');
    this.isNew = !this.getData();
    this.likeText = 'like';
    this.dislikeText = 'dislike';
    this.answers = {};
    this.dataLayerQueue = {};
    this.flags = ['subscriber', 'completed', 'unsaved'];
    this.totalSteps = Array.from(document.querySelectorAll('.quiz-slide')).filter(slide => slide.dataset.step).length;
    this.completionPage = document.getElementById('quiz')?.dataset?.completionUrl || '/pages/plans-and-pricing';
    this.profilePage = this.vars.url.account.profile || '/pages/style-profile';
    this.templateVersion = document.querySelector('[data-version]').dataset.version;
    this.templateMinorVersion = document.querySelector('[data-minor-version]').dataset.minorVersion;
    this.preview = Shopify.theme.role === 'unpublished' && Shopify.theme.name.indexOf('Test') !== 0;
    this.maxUploadSize = 5; // MB
    this.testEmail = 'automatedtest@statelymen.com';
    this.debugStop = false; // prevent proceeding to plans page for debugging
    this.debugTestAsNewUser = false; // repeatedly test new user flow
    this.debug = this.debugStop || this.debugTestAsNewUser || this.preview || window.location.search.indexOf('sdebug=1') !== -1; // use this to display console messages
    this.isAutomatedTest = sessionStorage.getItem('utm_params') ? sessionStorage.getItem('utm_params').toLowerCase().indexOf('reflect') !== -1 : false;
    this.init();
  }

  init() {
    // Initialize quiz
    this.setupEventListeners();
    this.loadSavedData();
    this.setupSwiperListeners();

    if (window.location.search.indexOf('step=') === -1) {
      const firstSlide = document.querySelector('.quiz-slide.first');
      if (firstSlide) {
        firstSlide.classList.add('active');
      }
    }
  }

  setupSwiperListeners() {
    // Wait for Swiper to initialize, then add listeners
    setTimeout(() => {
      document.querySelectorAll('.quiz-slide-option-slider .swiper').forEach(swiperEl => {
        if (swiperEl.swiper) {
          swiperEl.swiper.on('slideChange', () => {
            // Reposition badges when slide changes
            setTimeout(() => {
              this.repositionCornerBadges();
            }, 50); // Small delay to ensure slide transition is complete
          });
        }
      });
    }, 500); // Wait for Swiper initialization
  }

  isMobile() {
    return window.innerWidth < 1200;
  }

  dataLayer(step, slideId, questionId, questionText, answerIds, responseText, additionalData) {
    let data = {
      event: 'style_' + (this.isStyleProfile ? 'profile' : 'quiz')
    };
    data['quiz_question_id'] = questionId;
    if (typeof(questionText) !== 'undefined' && questionText) {
      data['quiz_step_name'] = questionText;
    }

    let type = typeof(answerIds);
    if (type !== 'undefined' && answerIds) {
      if (type === 'object') {
        answerIds = answerIds.join(',');
      }
      data['quiz_answer_ids'] = answerIds;
    }

    type = typeof(responseText);
    if (type !== 'undefined' && responseText) {
      if (type !== 'string') {
        responseText = responseText.join('/');
      }
      data['quiz_response'] = responseText;
    }

    data['quiz_step'] = step;
    data['quiz_slide_id'] = slideId;
    data['quiz_version'] = this.templateVersion;
    data['quiz_minor_version'] = this.templateMinorVersion;

    if (typeof(additionalData) === 'object' && additionalData !== null) {
      Object.keys(additionalData).forEach(key => {
        data[key] = additionalData[key];
      });
    }

    this.dataLayerQueue[step] = data;
  }

  sendDataLayer() {
    if (!Object.keys(this.dataLayerQueue).length) return;
    if (this.debug) {
      console.log('DataLayer:', this.dataLayerQueue);
    }
    window.dataLayer = window.dataLayer || [];
    Object.values(this.dataLayerQueue).forEach(item => {
      window.dataLayer.push(item);
    });
    this.dataLayerQueue = {};
  }

  answersCompleted(slide, checkAll) {
    if (typeof checkAll === 'undefined') {
      checkAll = false;
    }
    const requiredNum = parseInt(slide.querySelector('[data-required]')?.dataset?.required) || 0;
    let required = requiredNum ? requiredNum : 0;
    let answered = 0;
    slide.querySelectorAll('[data-question-id]').forEach(question => {
      const selected = question.querySelectorAll('.selected').length || 0;
      const optional = question.dataset?.optional ? true : false;
      answered += checkAll ? selected : selected > 0 ? 1 : 0;
      if (!optional) {
        let numFields = 0;
        let numAnswers = 0;
        question.querySelectorAll('input:not([type="checkbox"]), select, textarea').forEach(input => {
          numFields++;
          numAnswers += (input.value && input.value.trim() !== '') ? 1 : 0;
        });
        if (numFields > 0 && numAnswers === numFields) {
          answered++;
        }
      }
      if (checkAll || (!requiredNum && !optional)) {
        required++;
      }
    });
    return answered >= required;
  }

  setOption(formOption, value) {
    if (!formOption) return;
    // Value will only be set on initialization

    let type = formOption.tagName.toLowerCase();
    if (type === 'input') {
      type = formOption.getAttribute('type').toLowerCase();
    }

    const question = formOption.closest('[data-question-id]');
    if (!question) return;
    const questionId = question.dataset.questionId || formOption.name;
    const isMultiple = question.dataset.multiple === 'true';

    const currentSlide = question.closest('[data-slide]');
    if (!currentSlide) return;

    const isSliderQuestion = question.classList.contains('slider-question');
    const isLikeDislike = isSliderQuestion && (formOption.value === this.likeText || formOption.value === this.dislikeText);

    const isInit = typeof value !== 'undefined';

    if (!isInit) {
      if (type === 'checkbox') {
        if (isLikeDislike) {
          // Never deselect if clicked
          formOption.checked = true;
        }
        value = formOption.checked ? formOption.value : '';
        console.log('Checkbox value set to:', value, formOption.checked);
      } else if (type === 'date') {
        const dateParts = formOption.value.split('-');
        if (dateParts.length === 3) {
          value = `${dateParts[1]}/${dateParts[2]}/${dateParts[0]}`;
        }
      } else {
        value = formOption.value || '';
      }
    }

    let isSet = typeof value !== 'undefined' && value !== null && value !== '' && value !== false;

    if (isInit) {
      if (type === 'checkbox') {
        if (isSliderQuestion && formOption.value != value) {
          formOption = formOption.closest('[data-question-id]').querySelector('input[value="' + value + '"]');
        }

        formOption.checked = isSet;
      } else if (type === 'file') {
        if (value) {
          const container = formOption.closest('label');
          container.querySelector('input[type="hidden"]').value = value;
          container.querySelector('.image-preview').innerHTML = this.getImagePreview(value);
        }
      } else {
        formOption.value = value;
      }
    }

    let optionValue = type === 'date' ? value : formOption.value;
    let displayValue = optionValue;
    
    if (type === 'checkbox') {
      const option = formOption.closest('[data-option-id]');
      if (!option) return;

      option.classList.toggle('selected', isSet);
      const optionText = option.textContent.trim();

      displayValue = isMultiple ? Array.from(question.querySelectorAll('[data-option-id].selected')).map(option => option.querySelector('label, .label')?.textContent.trim() || option.textContent.trim()) : option.querySelector('label, .label')?.textContent.trim() || option.textContent.trim();
      
      // Special handling for slider question
      if (isSliderQuestion) {
        // Prevent spam clicking - check if animation is already in progress
        if (!isInit && question.dataset.animating === 'true') {
          return;
        }
        
        if (isSet) {
          question.classList.add(optionValue);
        }
        if (!isInit) {
          question.classList.remove(optionValue === this.likeText ? this.dislikeText : this.likeText);
          
          // Mark as animating and disable buttons
          question.dataset.animating = 'true';
          const sliderOptions = question.querySelectorAll('.slider-option');
          sliderOptions.forEach(opt => {
            opt.style.pointerEvents = 'none';
            opt.style.opacity = '0.6';
          });
          
          // Create floating icon animation
          const iconType = optionValue === this.likeText ? 'heart' : 'x';
          this.createFloatingIcon(question, iconType);
          
          // Auto-advance to next slide after animation
          setTimeout(() => {
            currentSlide.querySelector('.swiper').swiper.slideNext();
            // Re-enable buttons (though user will be on next slide)
            question.dataset.animating = 'false';
            sliderOptions.forEach(opt => {
              opt.style.pointerEvents = '';
              opt.style.opacity = '';
            });
          }, 1100);
        } else {
          // On init, just show the corner badge without animation
          const iconType = optionValue === this.likeText ? 'heart' : 'x';
          this.updateCornerBadge(question, iconType);
        }
      }

      formOption.setAttribute('aria-checked', isSet);
      formOption.setAttribute('aria-label', isSet ? 'Selected: ' + optionText : 'Not selected: ' + option.textContent.trim());

      if (!isInit && !question.classList.contains('slider-question')) {
        // Deselect other options if not multiple choice
        const deselect = option.dataset.deselect?.length ? option.dataset.deselect : false;
        if (!isMultiple || deselect) {
          question.querySelectorAll('input[type="checkbox"]').forEach(opt => {
            if (opt !== formOption && opt.closest('[data-option-id]').classList.contains('selected')) {
              if (!deselect || deselect === 'all' || opt.closest(deselect)) {
                this.setOption(opt, false);
              }
            }
          });
        }

        // Scroll to freeform text input if revealed
        if (isSet) {
          const nextSibling = option.nextElementSibling;
          if (nextSibling && nextSibling.classList.contains('option-freeform')) {
            setTimeout(() => {
              nextSibling.scrollIntoView({ behavior: 'smooth', block: 'end' });
            }, 100);
          }
        }
      }
    } else if (type === 'select') {
      // Special handling for height 2 part select
      let optionList = false;
      let optionIds = question.dataset.optionIds ? question.dataset.optionIds : false;
      if (optionIds) {
        // Get decoded values
        optionList = {};
        const txt = document.createElement('textarea');
        txt.innerHTML = optionIds;

        // Remove double quotes from decoded value
        optionIds = txt.value.slice(1, -1);

        // Form into an array of name value pairs
        optionIds.split('\\n').forEach(line => {
          if (!line.trim()) return; // Skip empty lines

          // reverse the array
          const [value, key] = line.split(':').map(s => s.replace('\\', '').trim());
          optionList[Number(key)] = value;
        });
      }
      const selects = question.querySelectorAll('select');
      if (selects.length > 1) {
        if (isInit) {
          if (value) {
            let values = optionList && optionList[value] ? optionList[value] : value;
            displayValue = values;
            optionValue = value;

            values = values.split(' ');
            selects.forEach((select, i) => {
              if (i < values.length) {
                select.value = values[i];
              }
            });
          }
        } else {
          optionValue = [];
          let set = true;
          selects.forEach(select => {
            if (select.value) {
              optionValue.push(select.value);
            } else {
              set = false;
            }
          });
          displayValue = optionValue.join(' ');
          const key = optionList ? Object.keys(optionList).find(k => optionList[k] === displayValue) : false;
          optionValue = key ? key : displayValue;
          isSet = set;
        }
      } else {
        displayValue = formOption.options[formOption.selectedIndex].text.trim();
      }
      formOption.setAttribute('aria-selected', isSet);
      formOption.setAttribute('aria-label', isSet ? 'Selected: ' + displayValue : 'Not selected');
    } else if (type == 'email') {
      const isValid = this.validateEmail(value);
      this.toggleFormElementError(formOption, isValid);
      if (!isValid) {
        return;
      }
    } else if (type == 'date') {
      const isValid = this.validateDate(value);
      this.toggleFormElementError(formOption, isValid);
      if (!isValid) {
        return;
      }
    } else if (type == 'file') {
      if (value) {
         value = this.apiUrl + value;
      }
    }

    if (question.dataset.labelAppend && displayValue) {
      displayValue += question.dataset.labelAppend;
    }

    if (this.debug) {
      console.log('Question ID:', questionId, 'Display value:', displayValue, 'Option value:', optionValue, 'Is set:', isSet, 'Multiple:', isMultiple);
    }

    this.setAnswer(questionId, optionValue, isMultiple, !isSet, isInit);

    if (!isInit) {
      document.querySelector('#next-button').disabled = !this.answersCompleted(currentSlide);

      if (displayValue) {
        // Trigger dataLayer event
        const questionText = question.querySelector('.quiz-slide-question') ? question.querySelector('.quiz-slide-question').textContent.trim() : 
            (currentSlide.querySelector('.quiz-slide-question') ? currentSlide.querySelector('.quiz-slide-question').textContent.trim() : (currentSlide.querySelector('h3')?.textContent.trim() || false));
        if (questionText) {
          let additionalData = {};
          if (question.dataset.persona) {
            additionalData.quiz_persona = question.dataset.persona;
          }
          let stepNum = currentSlide.dataset.step;
          const questions = currentSlide.querySelectorAll('[data-question-id]');
          const questionNum = Array.prototype.indexOf.call(questions, question);
          if (questionNum > 0) {
            stepNum += '.' + questionNum;
          }

          question.querySelectorAll('.selected').forEach(response => {
            const nextSibling = response.nextElementSibling;
            if (nextSibling && nextSibling.classList.contains('option-freeform')) {
              const textarea = nextSibling.querySelector('textarea');
              if (textarea && textarea.value) {
                additionalData.quiz_text_response = typeof(additionalData.quiz_text_response) === 'undefined' ? textarea.value : '/' + textarea.value;
              }
            }
          });

          if (question.classList.contains('slider-question')) {
            additionalData.quiz_image_url = question.querySelector('img').src || '';
          }

          let answerIds = Array.from(question.querySelectorAll('[data-option-id].selected')).map(option => option.dataset.optionId);

          const slideId = currentSlide.dataset.slideId || '';

          this.dataLayer(stepNum, slideId, questionId, questionText, answerIds, displayValue, additionalData);
        }
      }

      // Check if all questions are answered
      if (isSet) {
        if (!isMultiple) {
          const autoAdvance = document.querySelector('[data-auto-advance]')?.dataset.autoAdvance || -1
          if (this.answersCompleted(currentSlide, true) && parseInt(autoAdvance) >= 0) {
            setTimeout(() => {
              this.nextSlide();
            }, parseInt(autoAdvance) * 200); 
          }
        }
      }
    }

    // Special case for slider
    if (isLikeDislike) {
      const savedData = this.getData();
      if (savedData && Object.keys(savedData).length > 0) {
        let likes = 0;
        let dislikes = 0;
        Object.keys(savedData).forEach(name => {
          let val = savedData[name];
          if (typeof val === 'string') {
            val = val.toLowerCase();
            if (val === this.likeText) {
              likes++;
            } else if (val === this.dislikeText) {
              dislikes++;
            }
          }
        });
        displayValue = ['Likes: ' + likes, 'Dislikes: ' + dislikes];
      }

      if (!isInit && question.dataset.styleIndex == question.closest('.quiz-slide-option-slider').dataset.styles) {
        document.getElementById('next-button').disabled = false;
        setTimeout(this.nextSlide.bind(this), 1200);
      }
    }

    let targetClass = false;
    if (type == 'file') {
      targetClass = formOption.classList[0];
      if (value) {
         displayValue = '<div class="image-preview ' + targetClass + '">' + this.getImagePreview(value) + '</div>';
      }
    }

    this.setSidebarOption(questionId, displayValue, targetClass);
  }

  setAnswer(questionId, value, isMultiple, remove, isInit) {
    if (!questionId || typeof value === 'undefined') {
      // old localStorage question or answer
      return;
    }
    isMultiple = typeof isMultiple === 'undefined' ? false : isMultiple;
    remove = typeof remove === 'undefined' ? false : remove;

    let unsaved = false;

    if (remove) {
      if (typeof this.answers[questionId] !== 'undefined') {
        unsaved = true;
        if (isMultiple && Array.isArray(this.answers[questionId])) {
          this.answers[questionId] = this.answers[questionId].filter(v => v !== value);
          if (this.answers[questionId].length === 0) {
            delete this.answers[questionId];
          }
        } else {
          delete this.answers[questionId];
        }
      }
    } else {
      if (isMultiple) {
        if (typeof this.answers[questionId] === 'undefined') {
          this.answers[questionId] = [];
        }
        if (!this.answers[questionId].includes(value)) {
          this.answers[questionId].push(value);
          unsaved = true;
        }
      } else {
        if (!this.answers[questionId] || this.answers[questionId] !== value) {
          this.answers[questionId] = value;
          unsaved = true;
        }
      }
    }

    if (!isInit && unsaved) {
      this.answers.unsaved = true;
      if (this.isStyleProfile) {
        document.getElementById('save-button').disabled = false;
      }
    }

    this.storeData(this.answers);
  }

  setSidebarOption(questionId, content, targetClass) {
    targetClass = typeof targetClass === 'undefined' ? '' : targetClass;
    let sidebarItem = document.querySelector(`.quiz-sidebar [data-question-id="${questionId}"]`);
    if (!sidebarItem) {
      sidebarItem = document.querySelector(`.quiz-sidebar [data-question-id*="${questionId},"]`);
    }
    if (!sidebarItem) return;

    if (typeof content === 'object' && content !== null) {
      content = content.join('<br />');
    }
    
    const response = sidebarItem.querySelector('.quiz-sidebar-response');
    if (targetClass) {
      const itemPart = sidebarItem.querySelector('.' + targetClass);
      if (itemPart) {
        itemPart.outerHTML = content;
      } else {
        response.insertAdjacentHTML('beforeend', content);
      }
    } else {
      response.innerHTML = content;
    }

    const completed = response.innerHTML.length > 0;
    if (completed) {
      const label = sidebarItem.querySelector('.quiz-sidebar-label');
      const labelText = label.textContent.trim();
      const ariaLabel = 'Go to ' + labelText + ' question';
      label.innerHTML = '<span tabindex="0" role="button" aria-label="' + ariaLabel + '">' + labelText + '</span>';
    }
    sidebarItem.classList.toggle('completed', completed);
  }

  setIconPosition(element, img) {
    // Wait for next frame to ensure layout is complete
    requestAnimationFrame(() => {
      const topOffset = img.offsetTop || 0;
      const leftOffset = img.offsetLeft || 0;
      const imgWidth = img.offsetWidth || img.naturalWidth || 500;
      
      // Set CSS custom properties for positioning
      element.style.setProperty('--img-top-offset', `${topOffset}px`);
      element.style.setProperty('--img-left-offset', `${leftOffset}px`);
      element.style.setProperty('--img-width', `${imgWidth}px`);
    });
  }

  createFloatingIcon(question, type) {
    // Remove any existing corner badge first
    const existingBadge = question.querySelector('.corner-badge');
    if (existingBadge) {
      existingBadge.remove();
    }

    const icon = document.createElement('div');
    icon.className = `floating-icon float-${type}`;
    
    // Check for custom icon from CMS
    const customIconUrl = type === 'heart' ? question.dataset.likeAnimationIcon : question.dataset.dislikeAnimationIcon;
    
    if (customIconUrl) {
      // Use custom uploaded icon
      const img = document.createElement('img');
      img.src = customIconUrl;
      img.alt = type === 'heart' ? 'Like' : 'Dislike';
      icon.appendChild(img);
    } else {
      // Use default SVG
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('viewBox', '0 0 24 24');
      
      const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      
      if (type === 'heart') {
        path.setAttribute('d', 'M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z');
        path.setAttribute('fill', '#e1eb75');
      } else {
        path.setAttribute('d', 'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z');
        path.setAttribute('fill', '#ff4757');
      }
      
      svg.appendChild(path);
      icon.appendChild(svg);
    }
    
    question.appendChild(icon);
    
    // Get image dimensions and position relative to parent
    const img = question.querySelector('img');
    if (img) {
      this.setIconPosition(icon, img);
    }
    
    // Convert floating icon to corner badge after animation completes
    setTimeout(() => {
      icon.classList.remove('floating-icon', `float-${type}`);
      icon.classList.add('corner-badge');
      icon.style.animation = 'none';
    }, 1000);
  }

  updateCornerBadge(question, type) {
    // Remove existing badge
    const existingBadge = question.querySelector('.corner-badge');
    if (existingBadge) {
      existingBadge.remove();
    }
    
    if (type === null) return;
    
    const badge = document.createElement('div');
    badge.className = 'corner-badge';
    
    // Check for custom icon from CMS
    const customIconUrl = type === 'heart' ? question.dataset.likeAnimationIcon : question.dataset.dislikeAnimationIcon;
    
    if (customIconUrl) {
      // Use custom uploaded icon
      const img = document.createElement('img');
      img.src = customIconUrl;
      img.alt = type === 'heart' ? 'Like' : 'Dislike';
      badge.appendChild(img);
    } else {
      // Use default SVG
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('viewBox', '0 0 24 24');
      
      const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      
      if (type === 'heart') {
        path.setAttribute('d', 'M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z');
        path.setAttribute('fill', '#e1eb75');
      } else {
        path.setAttribute('d', 'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z');
        path.setAttribute('fill', '#ff4757');
      }
      
      svg.appendChild(path);
      badge.appendChild(svg);
    }
    
    question.appendChild(badge);
    
    // Get image dimensions and position relative to parent
    const img = question.querySelector('img');
    if (img) {
      // Check if image has loaded and has dimensions
      if (img.complete && img.naturalWidth > 0) {
        this.setIconPosition(badge, img);
      } else {
        // Wait for image to load
        img.addEventListener('load', () => {
          this.setIconPosition(badge, img);
        }, { once: true });
        // Fallback in case image is cached and load event doesn't fire
        setTimeout(() => {
          this.setIconPosition(badge, img);
        }, 100);
      }
    }
  }

  setupEventListeners() {
    const backButton = document.querySelectorAll('.back-button');
    backButton.forEach(button => {
      button.addEventListener('click', () => {
        this.previousSlide();
      });
    });

    const nextButton = document.querySelectorAll('.next-button');
    nextButton.forEach(button => {
      button.addEventListener('click', () => {
        if (!button.disabled) {
          this.nextSlide();
        }
      });
    });

    if (this.isStyleProfile) {
      const saveButton = document.querySelectorAll('.save-button');
      saveButton.forEach(button => {
        button.addEventListener('click', () => {
          if (!button.disabled) {
            saveButton.disabled = true;
            this.checkCustomerStatus();
          }
        });
      });
    }

    document.querySelectorAll('#modal-overlay, .modal-close').forEach(element => {
      element.addEventListener('click', (e) => {
        if (e.target.id === 'modal-overlay' || e.target.classList.contains('modal-close')) {
          document.getElementById('modal-overlay').classList.remove('active');
        }
      });
      element.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Escape') {
          e.preventDefault();
          document.getElementById('modal-overlay').classList.remove('active');
        } 
      });
    });

    document.querySelectorAll('.quiz-slide [data-modal-id]').forEach(button => {
      button.addEventListener('click', () => {
        this.showModal(button.dataset.modalId);
      });
    });

    // Option selection using event delegation
    const quizSlides = document.querySelector('.quiz-slides');
    
    // Handle sidebar
    const sidebarOpener = document.querySelector('.quiz-sidebar-opener');
    sidebarOpener.addEventListener('click', () => {
      this.toggleSidebar();
    });
    document.getElementById('overlay').addEventListener('click', () => {
      this.toggleSidebar();
    });
    document.querySelector('.quiz-sidebar .modal-close').addEventListener('click', () => {
      this.toggleSidebar();
    });

    if (this.isStyleProfile && window.innerWidth < 1200) {
      // default to sidebar open on smaller devices
      document.querySelector('.quiz-sidebar-opener button').click();
    }


    document.querySelectorAll('.quiz-sidebar-block').forEach(block => {
      block.addEventListener('click', (e) => {
        if (e.target.closest('.quiz-sidebar-label')) {
          const blockItem = e.target.closest('.quiz-sidebar-block');
          if (this.isStyleProfile || blockItem.classList.contains('completed')) {
            const questionId = blockItem.dataset.questionId.split(',')[0];
            const question = document.querySelector(`.quiz-slides [data-question-id="${questionId}"]`);
            if (question) {
              const slide = question.closest('.quiz-slide');
              if (slide) {
                this.goToSlide(slide.dataset.step);
                if (sidebarOpener && window.getComputedStyle(sidebarOpener).display !== 'none') {
                  this.toggleSidebar();
                }
              }
            }
          }
        }
      });
    });

    quizSlides.querySelectorAll('input[type="checkbox"], select').forEach(formOption => {
      formOption.addEventListener('change', () => {
        this.setOption(formOption);
      });
    });

    quizSlides.querySelectorAll('input[type="text"], input[type="email"], input[type="date"], textarea').forEach(formOption => {
      formOption.addEventListener('input', (e) => {
        if (formOption.classList.contains('quiz-slide-option-freeform')) {
          this.setOption(formOption.closest('.option-freeform').previousElementSibling.querySelector('input[type="checkbox"]'));
        } else {
          this.setOption(formOption);
        }
      });

      formOption.addEventListener('keyup', (e) => {
        if (e.which === 13 && !nextButton.disabled) {
          document.getElementById('next-button').click();
        }
      });
    });

    quizSlides.querySelectorAll('input[type="file"]').forEach(formOption => {
      const questionId = formOption.closest('[data-question-id]').dataset.questionId;
      const imagePreview = formOption.closest('label').querySelector('.image-preview');
      const maxFileSize = this.maxUploadSize * 1024 * 1024; // Convert MB to bytes
      formOption.addEventListener('change', (input) => {
        if (input.target.files && input.target.files[0]) {
          if (input.size && input.size > maxFileSize) {
            let errorMsg = `File size exceeds maximum limit of ${this.maxUploadSize} MB for question ID ${questionId}.`;
            this.toggleFormElementError(formOption, false, errorMsg);
            console.error(errorMsg);
          } else {
            formOption.closest('label').querySelector('input[type="hidden"]').value = '';
            this.toggleFormElementError(formOption, true);
            let reader = new FileReader();
            reader.onload = (e) => {
              imagePreview.innerHTML = this.getImagePreview(e.target.result);
              this.setSidebarOption(questionId, imagePreview.outerHTML, formOption.classList[0]);
            };
            reader.readAsDataURL(input.target.files[0]);
          }
        }
      });
      
      // Handle image removal
      imagePreview.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (imagePreview.querySelector('img')) {
          if (confirm('Remove photo?')) {
            imagePreview.innerHTML = '';
            imagePreview.closest('label').querySelectorAll('input[type="hidden"]').forEach(input => input.value = '');
            this.toggleFormElementError(formOption, true);
            this.setOption(formOption, ''); // Update the answer
          }
        }
      });
    });

    // Handle keyboard navigation
    quizSlides.addEventListener('keyup', (e) => {
      // Enter or Space to select
      const option = e.target.closest('[data-option-id]');
      const question = e.target.closest('[data-question-id]');
      if (!option || !question) return;

      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (option) {
          option.click();
        } else if (!nextButton.disabled) {
          nextButton.click();
        }
      }
      
      // Arrow key navigation between options
      if (option) {
        const options = Array.from(question.querySelectorAll('.option'));
        const currentIndex = options.indexOf(option);
        
        let nextOption;
        
        switch (e.key) {
          case 'ArrowRight':
          case 'ArrowDown':
            e.preventDefault();
            nextOption = options[currentIndex + 1] || options[0];
            break;
          case 'ArrowLeft':
          case 'ArrowUp':
            e.preventDefault();
            nextOption = options[currentIndex - 1] || options[options.length - 1];
            break;
          case 'Tab':
            // If it's a multi-select and there are selections, allow tabbing to continue button
            if (question.dataset.multiple === 'true' && !nextButton.disabled) {
              if (!e.shiftKey && currentIndex === options.length - 1) {
                e.preventDefault();
                nextButton.focus();
              }
            }
            break;
        }
        
        if (nextOption) {
          nextOption.focus();
        }
      }
    });

    // Make option cards focusable and add ARIA attributes
    const setupOptionCards = () => {
      const activeSlide = document.querySelector('.quiz-slide.active');
      if (!activeSlide) return;
      
      const stepNumber = activeSlide.dataset.step;
      
      // Setup progress indicator
      if (stepNumber) {
        const progressBar = activeSlide.querySelector('.progressbar');
        if (progressBar) {
          progressBar.setAttribute('role', 'progressbar');
          progressBar.setAttribute('aria-valuemin', '0');
          progressBar.setAttribute('aria-valuemax', '100');
          progressBar.setAttribute('aria-valuenow', Math.round((stepNumber / 12) * 100));
          progressBar.setAttribute('aria-label', `Progress: Step ${stepNumber} of 12`);
        }
      }

      // Setup back and next buttons
      backButton.forEach(button => {
        button.setAttribute('tabindex', '1');
        button.setAttribute('role', 'button');
        button.setAttribute('aria-label', 'Go back to previous question');
      });
      nextButton.forEach(button => {
        button.setAttribute('tabindex', '1');
        button.setAttribute('role', 'button');
        button.setAttribute('aria-label', 'Go to next question');
      });

      activeSlide.querySelectorAll('.option').forEach(option => {
        const isMultiple = option.closest('[data-question-id]').dataset.multiple === 'true';
        option.setAttribute('tabindex', '1');
        option.setAttribute('role', isMultiple ? 'checkbox' : 'button');
        option.setAttribute(isMultiple ? 'aria-checked' : 'aria-pressed', option.classList.contains('selected'));
        // Update ARIA label to include the option text and whether it's selected
        const selectionState = option.classList.contains('selected') ? 'Selected: ' : '';
        option.setAttribute('aria-label', option.querySelector('label') ? selectionState + option.querySelector('label').textContent.trim() : selectionState + option.textContent.trim());
      });
    };

    // Setup initial slide
    setupOptionCards();

    // Setup cards when slide changes
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          if (mutation.target.classList.contains('active')) {
            setupOptionCards();
          }
        }
      });
    });

    document.querySelectorAll('.quiz-slide').forEach(slide => {
      observer.observe(slide, { attributes: true });
    });

    // Handle window resize - reposition corner badges
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        this.repositionCornerBadges();
      }, 150); // Debounce resize events
    });
  }

  repositionCornerBadges() {
    // Find all corner badges and recalculate their positions
    document.querySelectorAll('.slider-question .corner-badge').forEach(badge => {
      const question = badge.closest('.slider-question');
      
      // Only reposition if the question/slide is visible
      if (!question || question.offsetParent === null) return;
      
      const img = question.querySelector('img');
      
      if (img && img.offsetWidth > 0) {
        // Recalculate position based on current image dimensions
        const topOffset = img.offsetTop || 0;
        const leftOffset = img.offsetLeft || 0;
        const imgWidth = img.offsetWidth || img.naturalWidth || 500;
        
        badge.style.setProperty('--img-top-offset', `${topOffset}px`);
        badge.style.setProperty('--img-left-offset', `${leftOffset}px`);
        badge.style.setProperty('--img-width', `${imgWidth}px`);
      }
    });
  }

  validateEmail(email) {
    return email && /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email);
  }

  validateDate(date) {
    let valid = date && /^\d{2}\/\d{2}\/\d{4}$/.test(date); // Validate MM/DD/YYYY format
    if (valid) {
      // Validate date range
      const parts = date.split('/');
      const month = parseInt(parts[0], 10);
      const day = parseInt(parts[1], 10);
      const year = parseInt(parts[2], 10);
      const today = new Date();
      const newDate = new Date(year, month - 1, day);
      let age = today.getFullYear() - newDate.getFullYear();
      const monthDiff = today.getMonth() - newDate.getMonth();
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < newDate.getDate())) {
        age--;
      }
      valid = age >= 0 && age <= 115;
    }
    return valid;
  }

  getImagePreview(imageUrl) {
    if (!imageUrl) return '';
    if (!imageUrl.startsWith('http') && !imageUrl.startsWith('data:')) {
      imageUrl = this.apiUrl + imageUrl;
    }
    return `<img src="${imageUrl}" alt="Image preview" />`;
  }

  toggleFormElementError(formElement, isValid, message) {
    if (formElement) {
      formElement.classList.toggle('input-error', !isValid);
      formElement.setAttribute('aria-invalid', !isValid);
      formElement.setAttribute('aria-describedby', isValid ? '' : 'input-error');
      const invalidLabel = 'Invalid ';
      let label = formElement.getAttribute('aria-label') || 'input';
      label = label.replace(invalidLabel, '');
      formElement.setAttribute('aria-label', isValid ? label : invalidLabel + label);
      document.getElementById('next-button').disabled = !isValid;
      if (!isValid && message) {
        formElement.setAttribute('title', message);
      } else {
        formElement.removeAttribute('title');
      }
    }
  }

  // Data handling

  checkCustomerStatus(email) {
    if (this.debugStop) {
      console.clear();
    }

    let errorMsg = 'Failed to check customer status: ';

    if (typeof email === 'undefined') {
      let formData = this.getData();
      if (!formData || typeof formData['email'] === 'undefined' || !formData['email']) {
        email = document.querySelector('.quiz-slide-email input')?.value || statelyVars.customer?.email || '';
      } else {
        email = formData['email'];
      }
    }
    const validEmail = this.validateEmail(email);
    if (!validEmail) {
      errorMsg += 'Missing or invalid email address ' + email;
      console.error(errorMsg);
      this.complete(errorMsg);
    }

    if (email.indexOf(this.testEmail) !== -1) {
      // Act like a new user
      this.debugTestAsNewUser = true;
    }

    if (!this.apiUrl || this.apiUrl.indexOf('http') !== 0) {
      errorMsg += 'Missing or invalid API URL';
      console.error(errorMsg);
      this.complete(errorMsg);
    }

    this.toggleLoading();

    const url = this.apiUrl + '/customer_check?email=' + encodeURIComponent(email);

    if (this.debug) {
      console.log('Checking customer status for email:', email, 'URL:', url);
    }

    fetch(url)
    .then(response => {
      if (this.debug) {
        console.log(response);
      }
      if (!response.ok) {
        this.toggleLoading();
        errorMsg += 'Invalid response status ' + response.statusText;
        console.error(errorMsg, response);
        this.complete(errorMsg);
      }
      return response.json();
    })
    .then(data => {
      if (this.debug) {
        console.log('Customer status data:', data);
      }
      let formData = this.getData() || {};
      formData['email'] = email;
      if (data.active_subscriber) {
        formData.subscriber = true;
      }
      if (!this.isStyleProfile && data.active_subscriber && !this.debugTestAsNewUser) {
        this.toggleLoading();
        this.showModal('subscriber-warning');
        if (!this.debugStop) {
          document.body.addEventListener('click', () => {
            window.location.href = (window.statelyVars.customer ? '' : '/account?return_url=') + this.profilePage;
          });
        }
      } else {
        if (data.id) {
          localStorage.setItem('odoo_customer_id', data.id);
          this.submitData(formData);
        } else {
          this.toggleLoading();
          errorMsg += 'No customer ID found in response';
          console.error(errorMsg, data);
          this.complete(errorMsg);
        }
      }
    }).catch(error => {
      this.toggleLoading();
      errorMsg += 'Caught error: ' + (error.message || 'Unknown error');
      console.error(errorMsg, error);
      this.complete(errorMsg);
    });
  }

  submitData(formData) {
    if (this.debugStop && this.isStyleProfile) {
      console.clear();
    }

    let errorMsg = 'Failed to submit quiz data: ';

    const url = this.apiUrl + '/set_customer_quiz_data';

    formData['server_url'] = this.apiUrl;
    formData['customer_id'] = window.statelyVars.customer ? window.statelyVars.customer.id : '';
    formData['template_version'] = this.templateVersion;
    formData['business_name'] = '';

    let formDataArray = Object.entries(formData)
      .filter(([name]) => !this.flags.includes(name))
      .flatMap(([name, value]) =>
        Array.isArray(value)
          ? value.map(v => ({ name, value: v }))
          : [{ name, value }]
      );

    if (this.debug) {
      console.log('Submitting quiz data:', url, formDataArray);
    } 

    const self = this;
    $.ajax({
      url: url,
      type: "POST",
      crossDomain: true,
      data: formDataArray,
      success: function (response) {
        response = JSON.parse(response);
        console.log(response);

        if (!this.debugTestAsNewUser) {
          formData.completed = true;
        }

        self.storeData(formData);

        if (self.isStyleProfile) {
          const callback = (() => {
            self.showModal('style-profile-completion');
            document.body.addEventListener('click', () => {
              self.complete();
            });
          });
          self.submitUploads(formData, callback);
        } else {
          self.complete();
        }
      },
      error: function (xhr, status, error) {
        self.toggleLoading();
        errorMsg += 'Caught error: ' + (error || status);
        console.error(errorMsg, xhr.responseText);
        self.complete(errorMsg);
      }
    });
  }

  submitUploads(formData, callback) {
    let errorMsg = 'Failed to submit uploads: ';

    const url = this.apiUrl + '/set_customer_data';

    let uploadData = {
      'customer_id': window.statelyVars.customer.id,
      'addi_cid': window.statelyVars.customer.id,
      'customer_email': window.statelyVars.customer.email,
      'style_look_id': 'from_cp',
      'template_version': this.templateVersion,
      'saving_customer_data': true,
      'business_name': ''
    }

    document.querySelectorAll('.upload-options[data-question-id]').forEach(question => {
      const questionId = question.dataset.questionId;
      const multiple = question.dataset.multiple === 'true';
      const inputs = question.querySelectorAll('input[type="file"]');
      let num = 0;
      inputs.forEach(input => {
        const container = input.closest('label');
        const fieldName = questionId + (multiple ? `_${num}_multiimg` : '_img');
        uploadData[fieldName] = '';
        if (input.files && input.files.length > 0) {
          uploadData[fieldName] = container.querySelector('.image-preview img')?.currentSrc || '';
        } else {
          const hidden = container.querySelector('input[type="hidden"]');
          uploadData[fieldName] = hidden.value ? this.apiUrl + hidden.value : '';
        }
        num++;
      });
    });

    let formDataArray = Object.entries(uploadData)
      .filter(([name]) => !this.flags.includes(name))
      .flatMap(([name, value]) =>
        Array.isArray(value)
          ? value.map(v => ({ name, value: v }))
          : [{ name, value }]
      );

    if (this.debug) {
      console.log('Submitting upload data:', url, formDataArray);
    } 

    const self = this;
    $.ajax({
      url: url,
      type: "POST",
      crossDomain: true,
      data: formDataArray,
      success: function (response) {
        response = JSON.parse(response);
        console.log(response);

        callback();
      },
      error: function (xhr, status, error) {
        self.toggleLoading();
        errorMsg += 'Caught error: ' + (error || status);
        console.error(errorMsg, xhr.responseText);
        callback();
      }
    });
  }
  /*
  isComplete() {
    const savedData = JSON.parse(localStorage.getItem('quiz_data'));
    if (!savedData) return false;
    return typeof savedData.complete !== 'undefined' && savedData.complete;
  }
  */

  toggleLoading() {
    return;
    if (this.debugStop) {
      return false;
    }
    const loading = document.querySelector('.loading');
    if (loading) {
      loading.classList.toggle('active');
    }
    const overlay = document.getElementById('overlay');
    if (overlay) {
      overlay.classList.toggle('active');
    }
  }

  getStyleProfile(customerId, customerEmail) {
    let url = this.apiUrl + '/get_style_profile';

    const params = new URLSearchParams({
      customer_email: customerEmail,
      template_version: this.templateVersion
    });
    if (typeof customerId !== 'undefined' && customerId) {
      params.append('customer_id', customerId);
    }

    url += '?' + params.toString();

    if (this.debug) {
      console.log('Fetching style profile data from:', url);
    }
    
    fetch(url)
    .then(response => response.text())
    .then(data => {
      if (data) {
        const response = JSON.parse(data, true);
        if (response.success) {
          console.log(response.data);
          this.loadSavedData(response.data, true);
        } else {
          console.error('Issue with style profile data', response.error?.message || response);
          this.loadSavedData(null, true);
        }
      } else {
        if (this.debug) {
          console.log('No data found for style profile');
          this.loadSavedData(null, true);
        }
      }
    }).catch(error => {
      if (this.debug) {
        console.error('Error fetching style profile:', error);
        this.loadSavedData(null, true);
      }
    });
  }

  loadSavedData(savedData, isRecursive) {
    const isCustomer = this.customerId || false;
    if (typeof savedData === 'undefined' || savedData === null) {
      savedData = this.getData();
      // If style profile, load from customer account. Otherwise, load from localStorage if available and customer account if known
      isRecursive = typeof isRecursive === 'undefined' ? false : isRecursive;
      if (!isRecursive) {
        if (window.location.search.indexOf('email') !== -1) {
          const email = new URLSearchParams(window.location.search).get('email');
          if (this.validateEmail(email)) {
            return this.getStyleProfile(12345, email);
          }
        }
        if (isCustomer && (!savedData || Object.keys(savedData).length === 0 || this.isStyleProfile)) {
          return this.getStyleProfile(this.customerId, this.customerEmail);
        }
      }
    }

    let step = 0;
    let flags = [];
    if (savedData && Object.keys(savedData).length > 0) {
      try {
        Object.keys(savedData).forEach(name => {

          if (this.flags.includes(name)) {
            flags.push(name);
          }

          const value = savedData[name];

          if (value === null || value === '') {
            return;
          }

          let formElement = false;
          if (typeof value === 'object') {
            // Special case for file uploads
            const fileInputs = document.querySelectorAll(`[data-question-id="${name}"] input[type="file"]`);
            if (fileInputs.length > 0) {
              fileInputs.forEach((element, i) => {
                formElement = element; 
                this.setOption(formElement, value[i]);
              });
            } else {
              // If the value is an array, check if it's a multiple choice answer
              value.forEach(optionId => {
                let element = document.querySelector(`[data-option-id="${optionId}"] input`);
                if (element) {
                  formElement = element;
                  this.setOption(formElement, optionId);
                }
              });
            }
          } else {
            if (isNaN(Number(name))) {
              formElement = document.querySelector(`[data-slide] [name="${name}"]`);
            } else if (!isNaN(Number(value))) {
              formElement = document.querySelector(`[data-question-id="${name}"] [data-option-id="${value}"] input`);
            }
            if (!formElement) {
              formElement = document.querySelector(`[data-question-id="${name}"] input, [data-question-id="${name}"] select, [data-question-id="${name}"] textarea`);
            }
            if (formElement) {
              this.setOption(formElement, value);
            }
          }

          if (typeof value === 'undefined' || !value || !formElement) return;

          const slide = formElement.closest('[data-slide]');
          if (!slide) return;

          step = Math.max(slide.dataset.step, step);
        });
      } catch (e) {
        console.error('Error loading saved answers:', e);
      }
    }

    if (window.location.search.indexOf('step=') !== -1) {
      const step = new URLSearchParams(window.location.search).get('step');
      this.goToSlide(step);
    } else if (!this.isStyleProfile) {
      if (flags.includes('subscriber')) {
        this.showModal('subscriber-warning');
      }

      if (step) {
        // enable continue mode
        const continueButton = document.querySelector('.quiz-slide-button .continue-button');
        const nextButton = document.querySelector('.quiz-slide-button .next-button');
        const startOverText = nextButton.dataset.startOverText || 'Start From Beginning';
        nextButton.textContent = startOverText;
        nextButton.setAttribute('aria-label', startOverText);
        continueButton.style.display = 'inline-block';
        nextButton.classList.add('text-button');
        continueButton.addEventListener('click', () => {
          if (flags.includes('completed')) {
            this.complete();
          } else {
            this.goToSlide(step);
          }
        });
      }

      document.querySelector('.quiz-slide-button').classList.add('visible');
    }
  }

  filterData(formData, isSubmit) {
    let fieldNames = ['email'];
    if (typeof(isSubmit) === 'undefined') {
      fieldNames = [...fieldNames, this.flags];
    }

    const filteredData = Object.fromEntries(
      Object.entries(formData).filter(([name, value]) => (fieldNames.includes(name) || !isNaN(Number(name))) && typeof value !== 'undefined' && value !== null && value !== '')
    );

    return filteredData;
  }

  getData() {
    const savedData = JSON.parse(localStorage.getItem('quiz_data'));
    if (savedData && Object.keys(savedData).length > 0) {
      return savedData;
    }

    return false;
  }

  storeData(formData) {
    localStorage.setItem('quiz_data', JSON.stringify(this.filterData(formData)));
  }

  // Modal
  showModal(label, description) {
    if (typeof(description) === 'undefined') {
      if (!label) {
        console.error('Label required to show modal');
        return;
      }
      label = document.querySelector('#' + label + '.modal-content');
      if (label) {
        description = label.innerHTML;
        label = label.dataset.label;
      } else {
        console.error('Modal label not found: ', label);
        return;
      }
    }

    const modal = document.getElementById('modal-overlay');
    modal.querySelector('.modal-label').textContent = label;
    modal.querySelector('.modal-description').innerHTML = description;
    
    // Add class to any elements containing <em> tags
    modal.querySelectorAll('.modal-description em').forEach(em => {
      const parent = em.parentElement;
      if (parent && !parent.classList.contains('has-emphasis')) {
        parent.classList.add('has-emphasis');
      }
    });
    
    modal.classList.add('active');
  }

  toggleSidebar() {
    const sidebar = document.querySelector('.quiz-sidebar');
    const overlay = document.getElementById('overlay');
    if (sidebar) {
      sidebar.classList.toggle('active');
      if (overlay) {
        overlay.classList.toggle('active');
      }
      if (sidebar.classList.contains('active')) {
        sidebar.setAttribute('aria-hidden', 'false');
      } else {
        sidebar.setAttribute('aria-hidden', 'true');
      }
    } else {
      console.error('Quiz sidebar not found');
    }
  }

  // Navigation

  updateProgressBar() {
    const step = document.querySelector('.quiz-slide.active').dataset.step;
    const totalSteps = parseInt(document.querySelector('.total-steps').textContent);
    document.querySelector('.current-step').textContent = step;
    document.querySelector('.progressbar').style.width = (step / totalSteps * 100) + '%';
  }

  focusOnFirstInput(slide) {
    const children = Array.from(slide.querySelectorAll(`button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), .option-card[tabindex="1"]`));
    if (children.length === 0) return;

    // Find the child with the smallest top/left in the viewport
    const firstFocusable = children.reduce((first, el) => {
      const rect = el.getBoundingClientRect();
      if (!first) return el;
      const firstRect = first.getBoundingClientRect();

      return rect.top < firstRect.top ||
        (rect.top === firstRect.top && rect.left < firstRect.left)
        ? el
        : first;
}, null);

    if (firstFocusable) {
      setTimeout(() => {
        firstFocusable.focus();
      }, 100);
    }
  }

  targetNextStyle(slide) {
    const swiper = slide.querySelector('.swiper')?.swiper;
    if (!swiper) return;
    const target = slide.querySelector('.slider-question:not(:has(.corner-badge))');
    let slideTo = target ? Math.max(0, Number(target.dataset.styleIndex) - 1) : 0;
    if (slideTo === Number(slide.dataset.styles) - 1 || slideTo < 0) slideTo = 0;
    swiper.slideTo(slideTo);
  }

  nextSlide() {
    const currentSlide = document.querySelector('.quiz-slide.active');
    const nextSlide = currentSlide.nextElementSibling;

    if (nextSlide && nextSlide.classList.contains('quiz-slide')) {
      this.goToSlide(nextSlide.dataset.step);

      document.body.classList.add('quiz-progress');

      this.focusOnFirstInput(nextSlide);
    } else {
      //Last slide reached, submit data
      this.checkCustomerStatus();
    }

    this.sendDataLayer();
  }

  previousSlide() {
    const currentSlide = document.querySelector('.quiz-slide.active');
    const prevSlide = currentSlide.previousElementSibling;
    
    if (prevSlide && prevSlide.classList.contains('quiz-slide')) {
      this.goToSlide(prevSlide.dataset.step);

      if (parseInt(prevSlide.dataset.slideNumber) == 1) {
        document.body.classList.remove('quiz-progress');
      }

      this.focusOnFirstInput(prevSlide);
    }

    this.sendDataLayer();
  }

  goToSlide(step) {
    step = parseInt(step);
    const targetSlide = document.querySelector(`.quiz-slide[data-step="${step}"]`);
    if (targetSlide) {
      const currentSlide = document.querySelector('.quiz-slide.active');
      const skip = targetSlide.dataset.skip;
      if (skip === 'true' || (skip === 'repeat' && !this.isNew)) {
        if (step > (parseInt(currentSlide.dataset.step) || 0)) {
          return this.goToSlide(step + 1);
        } else {
          return this.goToSlide(step - 1);
        }
      }

      if (targetSlide.classList.contains('quiz-slide-slider')) {
        this.targetNextStyle(targetSlide);
      }

      if (currentSlide) {
        currentSlide.classList.remove('active');
        currentSlide.classList.add('hidden');
      }
      targetSlide.classList.remove('hidden');
      targetSlide.classList.add('active');
      document.body.classList.add('quiz-progress');

      // scroll slide to top
      if (this.isMobile()) {
        targetSlide.scrollIntoView({ behavior: 'auto', block: 'start' });
        window.scrollTo({top: 0, behavior: 'auto'});
      } else {
        targetSlide.querySelector('.content').scrollIntoView({ behavior: 'auto', block: 'start' });
      }
      
      const backButton = document.getElementById('back-button');
      const nextButton = document.getElementById('next-button');
      if (backButton) backButton.disabled = parseInt(targetSlide.dataset.step) <= 1;
      if (nextButton) {
        nextButton.disabled = !this.answersCompleted(targetSlide) && !this.isAutomatedTest;
      }
      
      // Update browser history without triggering popstate
      if (window.history && window.history.pushState) {
        const currentUrl = new URL(window.location);
        currentUrl.searchParams.set('step', step);
        window.history.pushState({ step: step }, '', currentUrl.toString());
      }
    }
    this.updateProgressBar();
  }

  complete(errorMsg) {
    if (this.debugStop) {
      console.log('🪲 Style profile completion stopped for debugging');
      return;
    }
    let completeUrl = this.completionPage;
    if (this.isStyleProfile) {
      document.getElementById('save-button').disabled = false;
    } else {
      completeUrl += '?returnStep=' + this.totalSteps;
      if (errorMsg) {
        completeUrl += '&quizError=' + encodeURIComponent(errorMsg);
      }
    }
    window.location.href = completeUrl;
  }

}

if (document.getElementById('quiz')) {
  // Initialize quiz
  window.addEventListener('DOMContentLoaded', () => {
    window.stately.styleProfile = new StyleProfile();

    function nextSlide() {
      window.stately.styleProfile.nextSlide();
    }

    function previousSlide() {
      window.stately.styleProfile.previousSlide();
    }
  });

  // Handle browser back/forward buttons
  if (window.history && window.history.pushState) {
    window.addEventListener('popstate', (event) => {
      let step = 1;
      if (event.state && event.state.step) {
        // Navigate to the step from browser history
        step = event.state.step;
      } else {
        const urlParams = new URLSearchParams(window.location.search);
        step = parseInt(urlParams.get('step')) || step;
      }

      const targetSlide = document.querySelector(`[data-step="${step}"]`);
      const currentSlide = document.querySelector('.quiz-slide.active');
      
      if (targetSlide && currentSlide) {
        currentSlide.classList.remove('active');
        currentSlide.classList.add('hidden');
        targetSlide.classList.remove('hidden');
        targetSlide.classList.add('active');
        
        const backButton = document.getElementById('back-button');
        const nextButton = document.getElementById('next-button');
        if (backButton) backButton.disabled = parseInt(targetSlide.dataset.step) <= 1;
        if (nextButton) nextButton.disabled = !window.stately.styleProfile.answersCompleted(targetSlide) && !window.stately.styleProfile.isAutomatedTest;
        
        // Update progress bar
        window.stately.styleProfile.updateProgressBar();
      }
    });
  }
}
